import { SessionStore } from '@backend/auth'
import { NotificationEventType } from '@core/types'
import { Injectable, Logger } from '@nestjs/common'
import { Subject } from 'rxjs'

@Injectable()
export class EventService {
	private readonly logger = new Logger(EventService.name)

	private readonly eventSubject = new Subject<{ tenantId: string; userId?: string; type: NotificationEventType }>()
	readonly event$ = this.eventSubject.asObservable()

	send(type: NotificationEventType): void {
		const tenantId = SessionStore.tenantId
		const userId = SessionStore.userId
		if (tenantId) {
			this.eventSubject.next({ tenantId, userId, type })

			this.logger.debug('Sent websockets event', { tenantId, userId, type })
		}
	}
}
